import axios from "axios";
import { isPublicAppPath } from "../pages/public/publicSite";
import { isNetworkError, reportNetworkIssue } from "../utils/networkMonitor";

const getBaseURL = () => {
  if (import.meta.env.DEV) {
    return "http://localhost:5000/api";
  }
  if (import.meta.env.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL;
  }
  return "http://localhost:5000/api";
};

const apiClient = axios.create({
  baseURL: getBaseURL(),
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add token if available
apiClient.interceptors.request.use(
  (config) => {
    try {
      const token = localStorage.getItem("token"); // Retrieve token from localStorage
      if (token) {
        config.headers.Authorization = `Bearer ${token}`; // Set Authorization header
      }
    } catch (e) {
      console.error("LocalStorage access failed:", e);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for handling errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const isDesktop = typeof window !== "undefined" && window.desktop;
    const redirectToSignIn = () => {
      const path = window.location.pathname || "";
      if (isPublicAppPath(path)) return;

      // Check if we are on a portal route
      const isPortalRoute = path.includes('portal') ||
        path.includes('client') ||
        window.location.hash.includes('portal') ||
        window.location.hash.includes('client');

      const targetPath = isPortalRoute ? "/portal/login" : "/auth/signin";
      const desktopPath = isDesktop ? `#${targetPath}` : targetPath;

      if (isDesktop && !window.location.hash.includes(targetPath)) {
        window.location.hash = targetPath;
      } else if (!isDesktop && !window.location.pathname.includes(targetPath)) {
        window.location.href = targetPath;
      }
    };

    if (isNetworkError(error)) {
      reportNetworkIssue("api");
    }

    if (error.response?.status === 401) {
      const header =
        error.config?.headers?.Authorization ||
        error.config?.headers?.authorization ||
        "";
      const usedToken = String(header).replace(/^Bearer\s+/i, "");
      let currentToken = null;
      try {
        currentToken = localStorage.getItem("token");
      } catch (e) { }
      // A request that started before login, or with an older token, must not
      // wipe the session that just signed in.
      const staleSession = !usedToken || (currentToken && usedToken !== currentToken);
      if (!staleSession) {
        try {
          localStorage.removeItem("token");
          localStorage.removeItem("authState");
        } catch (e) { }
        redirectToSignIn();
      }
    }
    return Promise.reject(error?.response?.data || error?.message || "Something went wrong");
  }
);

export default apiClient;
